import * as stylex from "@stylexjs/stylex";
import { Book32 } from "icons/Book";
import { breakpoints, colors } from "../../materials/consts.stylex";
import { typography } from "../../materials/typography.stylex";
const styles = {
    button: {
        k7Eaqz: "xgqtt45 x1hh2v2l",
        kMzoRj: "xmkeg23",
        ksu8eU: "x1y0btm7",
        kVAM5u: "x1wzfk3z",
        kMwMTN: "x12klvby",
        kWkggS: "xjbqb8w",
        k1xSpc: "x78zum5",
        kGNEyG: "x6s0dn4",
        kOIVth: "xou54vl",
        kmVPX3: "x1tamke2",
        kkrTdU: "x1ypdohk",
        kGzVvX: "xrvoegg",
        $$css: true
    }
};
export function ReferenceButton({ url, children }) {
    return <a href={url} target="_blank" rel="noreferrer" className="xeq5yr9">
      <button {...stylex.props(typography.body2, styles.button)}>
        <Book32/>
        {children}
      </button>
    </a>;
}
